// @ts-check
import angular from 'angular'
import differenceInHours from 'date-fns/difference_in_hours'
import differenceInMinutes from 'date-fns/difference_in_minutes'
import msgCtrl from '../job/message/message.ctrl'
import msgTpl from '../job/message/message.html'
import addWorkerCtrl from '../job/addWorker/addWorker.ctrl'
import addWorkerTpl from '../job/addWorker/addWorker.html'
import dsbCtrl from '../workforce/rate/dsb.ctrl'
import dsbTpl from '../workforce/rate/dsb.html'
import rateTpl from '../workforce/rate/rate.html'
import shiftProfileCtrl from './shift-profile/shift-profile.ctrl'
import shiftProfileTpl from './shift-profile/shift-profile.html'
import shiftDetailsCtrl from './shift-details/shift-details.ctrl'
import shiftDetailsTpl from './shift-details/shift-details.html'
import endAssignmentTpl from './end-assignment-modal/end-assignment-modal.html'
import endAssignmentCtrl from './end-assignment-modal/end-assignment-modal.ctrl'
import extendAssignmentTpl from './extend-assignment-modal/extend-assignment-modal.html'
import extendAssignmentCtrl from './extend-assignment-modal/extend-assignment-modal.ctrl'
import { absentModalController } from './absent-modal/absent-modal.ctrl.js'
import { excusedAllAbsentModalController } from './excused-all-absent-modal/excused-all-absent-modal.ctrl.js'
import excusedAllAbsentTemplate from './excused-all-absent-modal/excused-all-absent-modal.html'
import absentModalTemplate from './absent-modal/absent-modal.html'
import showEditTimeCtrl from './clock/clock.ctrl.js'
import showEditTimeTpl from './clock/clock.html'
import showClockInOutCtrl from './clock-in-out/clock-in-out.ctrl.js'
import showClockInOutTpl from './clock-in-out/clock-in-out.html'
import { ScheduleType } from '../../databaseEnums'
import { Category, CATEGORY_MAP, ReasonCode, REASON_MAP, ReasonCodesForFiltering } from "./constants";
import { findV1Job } from "./roster.utils.js"

import moment from 'moment-timezone'
import { extendMoment } from 'moment-range'

const momentRange = extendMoment(moment)
import { groupBy, difference, uniqBy, memoize, debounce, get, sortBy } from 'lodash'
import { ap, apply, prepend, of, filter, clone, omit, length, keys, prop, find, propEq, pipe, findIndex, map, identity, pickBy, dissoc, isEmpty } from 'ramda'
import cancelShiftModalCtrl from './cancel-shift-modal/cancel-shift-modal.ctrl'
import cancelShiftModal from './cancel-shift-modal/cancel-shift-modal.html'
import { processDownloadedFile } from '../../shared/utils'
import { getCovidPolicyIcon } from '../../component-templates/certification-icon/utils.js'
import { getSplitAttributes } from '../../shared/split.js'


// Segment events
const rosterFilterEvent = 'roster_filter_click'
const weeklyRosterPageView = 'weekly_roster_page_view'

// roster week / month toggles
const DEBOUNCE_TIME = 500;
const FILTER_DEBOUNCE_TIME = 300;

const CREW_MEMBERS_BATCH = CONFIG.ROSTER_CREW_MEMBER_BATCH || 50;

export const DateViewToggle = Object.freeze({
  Weeks: 'weeks',
  Days: 'days',
});

class currentJobsController {
  /* @ngInject */
  constructor(
    $state,
    $document,
    $mdDialog,
    $mdPanel,
    $mdToast,
    Jobs,
    ManageJobs,
    Companies,
    myCrews,
    userInfo,
    company,
    Users,
    $location,
    $scope,
    Auth,
    Shifts,
    $filter,
    $stateParams,
    PayrollService,
    segment,
    $window,
    $mdSidenav,
    futureShiftService,
    $interval,
    rosterUserCertificationService,
    UsersService,
  ) {
    this.$state = $state
    this.Auth = Auth
    this.$mdDialog = $mdDialog
    this.$mdPanel = $mdPanel
    this.PayrollService = PayrollService
    this.phoenixAppUrl = CONFIG.PHOENIX_APP_BASE
    this.$mdToast = $mdToast
    this.$window = $window
    this.$mdSidenav = $mdSidenav
    this.$scope = $scope
    this.showUnfilledShifts = false
    this.Jobs = Jobs
    this.ManageJobs = ManageJobs
    this.Users = Users
    this.Shifts = Shifts
    this.segment = segment
    this.clockBlock = false;
    this.usersAllShifts = {}
    /**
     * @type {{[userId: number]: number}}
     */
    this.usersFutureShiftsFromToday = {};
    this.dateViewToggle = this.$window.localStorage.getItem('dateViewToggle')
    // Use Map for O(1) lookups instead of array searches
    this.userShiftsMap = new Map();
    this.groupedShiftsByUser = []
    this.daysOfWeekData = []
    this.groupedUnfilledShifts = {}
    this.hasDuplicateShifts = (arr) => difference(arr, uniqBy(arr, 'day'), 'day').length
    this.daysOfWeek = []
    this.moment = moment
    this.showLoaderCircle = true
    // initialize my workforce
    this.myWorkforce = []
    this.shifts = []
    this.showShifts = [] // this is the array of filtered shifts that are displayed on the page
    this.all = [] // this is the array that contains all shifts that will eventually be filtered to be displayed in `this.showShifts`
    this.userCanPostJobs = userInfo.can('POST_NEW_JOB')
    this.isOpen = false
    this.calculateFacetCount = (arr, key, facet) => {
      const filtered = this.getFilteredWeeklyResults(this.weeklyRosterCrewCopy, facet, key)
      this.facetCount = filtered.length

      return this.facetCount
    }
    this.convertMinutesToHours = (minutes) => Math.trunc(minutes / 60)
    this.dateIsThisWeek = (date) => {
      const first = moment(this.daysOfWeek[0])
      const last = moment(this.daysOfWeek[this.daysOfWeek.length - 1])
      const md = moment(date)

      // date format is YYYY-MM-DD
      return (md.isSame(first) || md.isAfter(first)) && (md.isSame(date) || md.isBefore(last))
    }
    this.Category = Category
    this.ReasonCode = ReasonCode
    this.futureShiftsSubscription = null

    // Prefetching state variables
    this.prefetchedBatch = null
    this.prefetchInProgress = false

    this.handleScheduleRedirect = (shifts) => {
      this.$window.location.href = `${this.$scope.$parent.app.reactAppUrl}/schedules/${shifts[0].schedule_id}`
    }
    this.rosterUserCertificationService = rosterUserCertificationService;
    Users.getWorkforce().then((workForce) => {
      // set the workforce once we fetch it
      this.myWorkforce = workForce
    }).catch((err) => {
      console.log(err)
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('body')))
          .clickOutsideToClose(true)
          .title('Server Error')
          .textContent('There was an error fetching your workforce. Please try again later.')
          .ariaLabel('Server Error')
          .ok('OK')
      ).then($state.go('login'))
    })
    this.selectedWorkers = []
    this.myCrews = myCrews
    this.company = company
    this.Companies = Companies
    this.dayShift = []
    this.swingShift = []
    this.nightShift = []
    this.filterArray = []
    this.$location = $location
    this.filter = {}
    this.$filter = $filter
    this.now = new Date()
    this.getTodaysDate = () => moment(this.now).format('YYYY-MM-DD');
    this.isTodaysDate = (date) => moment(date).isSame(this.now, 'day')
    this.calculateDaysFrom = (date) => {
      const currentTime = moment.tz(this.now, moment.tz.guess()).format('H:mm')
      const timeAndDate = moment(date + ' ' + currentTime)
      return moment(timeAndDate).fromNow()
    }
    this.hasMatchingDate = (arr, prop) => arr.some(el => el.day === prop)
    this.stateParams = $stateParams
    if ($stateParams.tab) {
      this.filterCategory = $stateParams.tab
    } else {
      this.filterCategory = 'all'
    }
    this.daysFromShifts = (shifts) => shifts.map(s => s.day)
    this.UsersService = UsersService
    // first, check a flag for showing data by days or weeks
    this.getFeatureFlags()

    /**
     * Used in conjunction with hasDuplicateShifts(shifts) to determine if a 'shift-category-empty-container'
     * should be displayed in place. When a CM has more than one shift in any day in the week, they're essentially given
     * two rows of shifts displayed on the roster. On days when they only work 0 or 1 shifts, there's an empty
     * space which isn't visually appealing. This function is used to detect when a placeholder should be displayed to
     * fill up those empty spaces.
     *
     * Checks if there's 1 or fewer shifts for the given day. This is because if a 'add-shift-container' is displayed,
     * we still need to display a placeholder (shift-category-empty-container) to fill up the empty space but
     * it wouldn't count as a 'shift'.
     *
     * @param shifts
     * @param day {String} in format YYYY-MM-DD (e.g. '2023-09-18')
     * @returns {boolean} true if a placeholder should be displayed, false otherwise.
     */
    this.needsPlaceholderForDay = (shifts, day) => {
      const shiftsForDay = shifts.filter(shift => shift.day === day);
      return shiftsForDay.length <= 1;
    }

    const timer = $interval(() => {
      /**
       * This grabs the newest company timeestamps and updates the UI.
       * If a users_hours entry changes, there is not necessarily a new timestamp entry.
       * Because getting marked absent is done in users_hours but not in timestamps the UI will not update if a user gets marked absent based on this query alone.
       */
      this.getCompanyTimestamps(this.now);
      this.now = new Date();
      this.determinateValue = 0;
    }, 15000, 0);

    $scope.$on('$destroy',  () => {
      if (this.futureShiftsSubscription) {
        this.futureShiftsSubscription.unsubscribe();
      }
      this.futureShiftService.resetFutureShiftsMap();
      // Clear prefetch state
      this.prefetchedBatch = null;
      this.prefetchInProgress = false;
      $interval.cancel(timer);
    })

    // adding a custom class to the parent container when opening the filter menu to override styling
    $scope.$on('$mdMenuOpen', function () {
      var menuContentContainer = angular.element($document[0].querySelector('.weekly-roster-facets'))
      menuContentContainer.parent().addClass('weekly-roster-filter-container')
    })

    $scope.undoHours = (hoursId, roster) => {
      return this.PayrollService.undoHours({ hoursId: hoursId })
        .then(() => {
          this.Jobs.getIndividualRosterUpdates({
            companyId: roster.company_id,
            externalUserId: roster.external_id,
            shift: roster.shift,
            externalJobId: roster.job.external_id
          }).then((updatedRosterInfo) => {
            this.$scope.updateRosterProps(roster, updatedRosterInfo)
          }).catch((err) => {
            this.$mdToast.showSimple(err)
          })
          this.$mdToast.showSimple(`Unmarked ${roster.fullname} absent`)
        })
        .catch(err => {
          this.$mdToast.showSimple(err)
        })
    }

    /**
     * This function updates the props of a `roster` object in the arrays in which it is stored
     *
     * @param {Object} roster (Roster|User) type, which is updated in the arrays which they are stored
     * @param {Object} props The `roster` props to be overridden
     */
    $scope.updateRosterProps = (roster, props) => {
      let shiftIndex = findIndex(propEq('id', roster.id))(this.showShifts)
      let allIndex = findIndex(propEq('id', roster.id))(this.all)
      Object.keys(props).forEach(key => roster[key] = props[key]);
      if (!this.all[allIndex]) return
      this.showShifts[shiftIndex] = roster
      this.all[allIndex] = roster
      this.facetCounts()
    }

    $scope.clock = (type, roster) => {
      const updateClockInOutTime = (time) => {
        this.clockBlock = true
        const data = {
          jobId: roster.job.external_id,
          time: time,
          type,
          shift: roster.shift
        }
        this.Jobs.clock(data, [roster.external_id])
          .then((res) => {
            this.getCompanyTimestamps(this.now)
            this.now = new Date()
            this.determinateValue = 0
            this.clockBlock = false
            this.Jobs.getIndividualRosterUpdates({
              companyId: roster.company_id,
              externalUserId: roster.external_id,
              shift: roster.shift,
              externalJobId: roster.job.external_id
            }).then((updatedRosterInfo) => {
              this.$scope.updateRosterProps(roster, updatedRosterInfo)
            }).catch((err) => {
              this.$mdToast.showSimple(err)
            })
          })
          .catch((error) => {
            this.clockBlock = false
            this.$mdDialog.show(
              this.$mdDialog.alert()
                .clickOutsideToClose(true)
                .title('Clock Error')
                .content(error.data)
                .ariaLabel('Clock Error')
                .ok('Close')
            )
          })
      };

      let clockIn = {
        controller: showClockInOutCtrl,
        controllerAs: 'c',
        template: showClockInOutTpl,
        fullscreen: true,
        clickOutsideToClose: true,
        locals: {
          roster: roster,
          clockIn: type === 'SHIFT_START',
          // Passing clock in/out function,
          // to call it on submit in modal
          onClockInOutUpdate: updateClockInOutTime
        }
      }

      this.$mdDialog.show(clockIn)
    }

    this.determinateValue = 1
    this.futureShiftService = futureShiftService;
  }

  /**
   * Download the roster as a PDF or CSV for a given date or date range.
   * filename can be a date like '2023-09-18'
   * or a range like 2023-09-18_to_2023-09-25'
   * @param {string} fileName File type to download as
   * @param {'pdf' | 'csv'} fileType File type to download as
   * @returns
   */
  downloadRoster (fileName, fileType) {
    return this.Companies.getRoster(fileName, fileType)
      .then((res) => {
        processDownloadedFile(fileName, fileType, res.data)
      })
      .catch(() => {
        return this.$mdToast.showSimple('Roster Not Available')
      })
  }

  /**
   * @param {'pdf' | 'csv'} fileType
   * @returns
   */
  downloadRosterForDate (fileType) {
    return this.downloadRoster(String(this.pdfRosterDate), fileType)
  }

  /**
   * @param {'pdf' | 'csv'} fileType
   * @returns
   */
  downloadRosterForWeek (fileType) {
    const fileName = `${this.pdfRosterDate}_to_${this.pdfRosterWeekEndDate}`
    return this.downloadRoster(fileName, fileType)
  }

  absentIsLeftBtn = (shift) => {
    return (!this.isToday && shift.status === 'Previous')
  }

  getRosterCardClassName = (category, reasonCode) => {
    if (category === Category.MarkedAbsent) {
      if (Object.keys(REASON_MAP).includes(reasonCode?.toString())) {
        return REASON_MAP[reasonCode].class
      }
      return REASON_MAP.Default.class;
    }

    return CATEGORY_MAP[category]?.class ?? "";
  }

  getRosterCardTitle = (category, reasonCode) => {
    if (category === Category.MarkedAbsent) {
      if (Object.keys(REASON_MAP).includes(reasonCode?.toString())) {
        return REASON_MAP[reasonCode].text
      }
      return REASON_MAP.Default.text;
    }

    return CATEGORY_MAP[category]?.text ?? "";
  }

  isWeeksView() {
    return this.dateViewToggle === DateViewToggle.Weeks;
  }

  isDaysView() {
    return this.dateViewToggle === DateViewToggle.Days;
  }

  getDateViewToggle() {
    return this.dateViewToggle === DateViewToggle.Days ? DateViewToggle.Days : DateViewToggle.Weeks;
  }

  showShiftModal = ($event, shift) => {
    return this.showShiftDetails($event, shift);
  };

  showShiftProfile($event, shift, isMiniProfile = false) {
    const assignments = []
    const selectedUser = [this.userShiftsMap.get(shift.id)]
    const deDupedShifts = [...new Map(selectedUser[0].shifts.map(item => [item.job_id, item])).values()]
    const shiftCategoryClass = shift.category.replace(/-|\s/g, '').toLowerCase()
    const assignmentEndDate = this.getAssignmentEndDate(shift);
    const xPos = isMiniProfile ? 'OFFSET_END' : 'OFFSET_START'
    if (isMiniProfile) {
      this.jobs.map(job => {
        deDupedShifts.map(shift => {
          if (job.id === shift.job_id) {
            assignments.push(job)
          }
        })
      })
    }

    const position = this.$mdPanel.newPanelPosition()
      .relativeTo($event.currentTarget)
      .addPanelPosition(
        this.$mdPanel.xPosition[xPos],
        this.$mdPanel.yPosition.ALIGN_TOPS
      )

    const config = {
      attachTo: angular.element(document.body),
      controller: shiftProfileCtrl,
      controllerAs: 'ctrl',
      disableParentScroll: this.disableParentScroll,
      template: shiftProfileTpl,
      hasBackdrop: false,
      panelClass: 'shift-profile-panel',
      position: position,
      trapFocus: true,
      zIndex: 150,
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      locals: {
        assignments: assignments,
        dontSendBack: shift.dont_send_back,
        isMiniProfile: isMiniProfile,
        assignmentEndDate: assignmentEndDate,
        jobs: this.jobs,
        selectedShift: shift,
        selectedUser: selectedUser,
        shiftCategoryClass: shiftCategoryClass,
        undoHours: this.$scope.undoHours,
        updateRosterProps: this.$scope.updateRosterProps,
        clock: this.$scope.clock,
        userChatFn: this.$scope.$parent.app.userChatFn,
        reactAppUrl: this.$scope.$parent.app.reactAppUrl,
        phoenixExperience: this.phoenixExperience,
        covidPolicyOn: this.covidPolicyOn,
        singleShiftOn: this.singleShiftOn,  // TODO(BW-194): remove `singleShiftOn`
      }
    }

    this.$mdPanel.open(config)
  }

  getAssignmentEndDate = (shift) => this.jobs.filter(job => job.id === shift.job_id)[0].end_date;

  showShiftDetails($event, shift) {
    const userFromMap = this.userShiftsMap.get(shift.id);
    const selectedUser = userFromMap ? [userFromMap] : [];
    const shiftCategoryClass = shift.category.replace(/-|\s/g, '').toLowerCase();
    const assignmentEndDate = this.getAssignmentEndDate(shift);
    const xPos = 'OFFSET_START';

    const position = this.$mdPanel.newPanelPosition()
      .relativeTo($event.currentTarget)
      .addPanelPosition(
        this.$mdPanel.xPosition[xPos],
        this.$mdPanel.yPosition.ALIGN_TOPS
      );

    // We are picking first item in array since there is only one user there.
    // We are filtering out others in the previous steps of this function.
    const user = selectedUser[0]
    let shiftJob = this.usersAllShifts[user.id].jobs.find(job => job.jobId === shift.job_id);
    // iterate through the future shifts to annotate the shiftJob with the amount of shifts over all users this jobId has
    if (shiftJob) {
      this.addShiftCountsToJob(shiftJob, user.id, shiftJob.jobId)
    }
    const config = {
      attachTo: angular.element(document.body),
      controller: shiftDetailsCtrl,
      controllerAs: 'ctrl',
      template: shiftDetailsTpl,
      hasBackdrop: false,
      panelClass: 'shift-details-panel',
      position: position,
      trapFocus: true,
      zIndex: 150,
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      locals: {
        dontSendBack: shift.dont_send_back,
        userCanPostJobs: this.userCanPostJobs,
        getCompanyJobs: this.getCompanyJobs,
        assignmentEndDate: assignmentEndDate,
        jobs: this.jobs,
        selectedShift: shift,
        shiftJob: shiftJob,
        selectedUser: selectedUser,
        shiftCategoryClass: shiftCategoryClass,
        undoHours: this.$scope.undoHours,
        updateRosterProps: this.$scope.updateRosterProps,
        clock: this.$scope.clock,
        userChatFn: this.$scope.$parent.app.userChatFn,
        reactAppUrl: this.$scope.$parent.app.reactAppUrl,
        phoenixExperience: this.phoenixExperience,
        covidPolicyOn: this.covidPolicyOn,
      }
    }

    this.$mdPanel.open(config)
  }

  showAllExcusedModal($ev, jobs, groupedByDate, date) {
    let roster = {
      jobs: jobs,
      shifts: groupedByDate[date],
    }
    const confirm = {
      controller: excusedAllAbsentModalController,
      controllerAs: 'm',
      template: excusedAllAbsentTemplate,
      fullscreen: true,
      targetEvent: $ev,
      clickOutsideToClose: true,
      locals: {
        roster,
        date,
      }
    }
    return this.$mdDialog.show(confirm)
  }

  redirectPostJob() {
    this.$window.location.href = `${this.$scope.$parent.app.reactAppUrl}/jobs/post`
    return this.$window.location.href
  }

  getFeatureFlags() {
    this.Auth.splitClient.ready().then(() => {
      const attributes = getSplitAttributes(this.Auth);
      const covidPolicy = this.Auth.splitClient.getTreatment('covid19-workplace-policy-settings', attributes);
      this.phoenixExperience = false
      this.covidPolicyOn = covidPolicy !== 'off';
      this.drug_screening_p0_enabled = this.Auth.splitClient.getTreatment("drug_screening_p0", attributes) === "on"
      this.advanced_background_check_p0_enabled = this.Auth.splitClient.getTreatment("advanced_background_check_p0", attributes) === "on"
      this.initialCompanyJobsLoad()
    }).catch(() => {
      console.log('Error Initializing Split.io')
    })
  }

  initialCompanyJobsLoad() {
    if (!this.dateViewToggle) {
      this.dateViewToggle = DateViewToggle.Weeks
    }

    if (this.stateParams.date) {
      this.updateDateCutoffs(this.stateParams.date, this.dateViewToggle)
      this.isToday = moment(this.dateCutoff).isSame(this.now, 'day')
      this.todaysDate = this.stateParams.date
    } else {
      this.isToday = true
      this.updateDateCutoffs(this.now, this.dateViewToggle)
    }

    this.getCompanyJobs()
    //this.getLiveShiftsCounts()

    // Segment Event Tracking initial Weekly Roster page load
    if (this.isWeeksView()) {
      this.segment.track(weeklyRosterPageView)
    }
  }

  redirectTo(path) {
    return this.$location.path(path).replace()
  }


  /**
   * Updates the date range for the exported files based on the dateCutoff
   * @param {Date} dateCutoff - The starting date to use for the exported files
   */
  updatePdfRosterDates(dateCutoff) {
    this.pdfRosterDate = moment(dateCutoff).format('YYYY-MM-DD')
    this.pdfRosterWeekEndDate = moment(dateCutoff).add(1, 'week').format('YYYY-MM-DD')
  }

  /**
   * Updates the starting and ending dates to display on the roster
   *
   * @param {Date} date - The date we want to base the (start|end)cutoff dates off of
   * @param {typeof DateViewToggle[keyof DateViewToggle]} dateViewToggle
   * @returns {void}
   */
  updateDateCutoffs(date, dateViewToggle) {
    const WEEKDAY_IDX = 1 // Monday
    let startDateCutoff, endDateCutoff
    if (dateViewToggle === DateViewToggle.Weeks) {
      startDateCutoff = moment(date).startOf(this.dateViewToggle).add(WEEKDAY_IDX, 'day').format()
      endDateCutoff = moment(date).endOf(this.dateViewToggle).add(WEEKDAY_IDX, 'day').format()
    } else {
      startDateCutoff = moment(date).startOf(this.dateViewToggle).format()
      endDateCutoff = moment(date).endOf(this.dateViewToggle).format()
    }

    this.dateCutoff = startDateCutoff
    this.futureDateCutoff = endDateCutoff
  }

  dateViewSwitch() {
    this.daysOfWeekData = []
    this.dateViewToggle = this.isWeeksView() ? DateViewToggle.Days : DateViewToggle.Weeks
    this.updateDateCutoffs(this.now, this.dateViewToggle)
    this.updatePdfRosterDates(this.dateCutoff)
    this.isDaysView() && this.redirectTo('roster/' + this.pdfRosterDate)
    this.isToday = moment(this.dateCutoff).isSame(this.now, 'day');
    this.resetFilters()
    this.$window.localStorage.setItem('dateViewToggle', this.dateViewToggle)
    this.getCompanyJobs();

    // Segment Event Tracking when toggling to Weekly Roster
    if (this.isWeeksView()) {
      this.segment.track(weeklyRosterPageView)
    }
  }

  toggleDate(toggle) {
    this.updateDateCutoffs(toggle, this.dateViewToggle)
    this.updatePdfRosterDates(this.dateCutoff)
    this.$location.path('roster/' + this.pdfRosterDate).replace()
    this.isToday = moment(this.dateCutoff).isSame(this.now, 'day')
    this.getCompanyJobs();
  }

  incrementDate() {
    this.dateViewToggle = this.getDateViewToggle()
    this.dateCutoff = moment(this.dateCutoff).add(1, this.dateViewToggle).format()
    this.futureDateCutoff = moment(this.futureDateCutoff).add(1, this.dateViewToggle).format()
    this.updatePdfRosterDates(this.dateCutoff)
    this._updateView();
  }

  decrementDate() {
    this.dateViewToggle = this.getDateViewToggle()
    this.dateCutoff = moment(this.dateCutoff).subtract(1, this.dateViewToggle).format()
    this.futureDateCutoff = moment(this.futureDateCutoff).subtract(1, this.dateViewToggle).format()
    this.updatePdfRosterDates(this.dateCutoff)
    this._updateView();
  }

  /**
   * a debounced function that will update the route and get the new jobs for the view once the user has stopped clicking the previous
   * or next buttons
   * @type {DebouncedFunc<function(*): void>}
   * @private
   */
  _updateView = debounce(() => {
    this.$location.path('roster/' + this.pdfRosterDate).replace()
    this.isToday = moment(this.dateCutoff).isSame(this.now, 'day')
    //this.getCompanyJobs();
  }, DEBOUNCE_TIME);
  /*
   Build the url for redirecting to GetCrewForm (web-react) with pre-populated URL params
   */
  buildDirectHireUrl(user_external_id, position_id) {
    const directInviteUserIdParam = `directInviteUserIds=${JSON.stringify(user_external_id)}`;
    const directInvitePositionParam = `position=${position_id}`;
    const reactAppUrl = this.$scope.$parent.app.reactAppUrl;
    return `${reactAppUrl}/jobs/post?${directInviteUserIdParam}&${directInvitePositionParam}`;
  }

  /*
 Build the url for redirecting to GetCrewForm (web-react) with pre-populated URL params
 */
  buildDirectHireUrlWithNoUserNorPosition() {
    const reactAppUrl = this.$scope.$parent.app.reactAppUrl;
    return `${reactAppUrl}/jobs/post?directInviteUserIds=""`;
  }

  /*
   Redirect to GetCrewForm (web-react) with pre-populated URL params
   to direct hire a user. Position ID is inferred from the user's latest scheduled job.
   */
  directHireRepeatingSchedule(user) {
    this.directHire(user, null);
  }

  /*
   Redirect to GetCrewForm (web-react) with pre-populated URL params
   to direct hire a user
   */
  directHireFromDayView(shift) {
    // This function is not re-using directHire(user, shiftDate) because the
    // shift object is not constructed the same way as the user object
    let directInviteUrl = this.buildDirectHireUrl(shift.external_id, shift.position_id);
    this.$window.location.href = directInviteUrl;
  }

  /*
   Format shift date from "YYYY-MM-DD" to "MM-DD-YYYY"
   */
  formatShiftDateToQueryParameterValue(date) {
    return moment(date).format("MM-DD-YYYY");
  }

  /*
   Redirect to GetCrewForm (web-react) with pre-populated URL params
   for direct hire user with a shiftDate (in case of single-shift).
   Position ID is inferred as the user's latest scheduled job.
   */
  directHire(user, shiftDate, singleShift) {
    const latestShift = user.shifts.reduce((x, y) => (x.day > y.day ? x : y)); // We make the assumption that user.shifts is non-empty
    let directInviteUrl = this.buildDirectHireUrl(
      user.external_id,
      latestShift.position_id
    );
    let formattedShiftDate;
    if (shiftDate) {
      formattedShiftDate = this.formatShiftDateToQueryParameterValue(shiftDate);
      directInviteUrl += `&startShiftDate=${formattedShiftDate}&endShiftDate=${formattedShiftDate}`;
    }
    const startTime = moment
      .tz(latestShift.start_time, latestShift.timezone)
      .format("HH:mm");
    const endTime = moment
      .tz(latestShift.end_time, latestShift.timezone)
      .format("HH:mm");
    directInviteUrl += `&startTime=${startTime}&endTime=${endTime}`;
    directInviteUrl += `&scheduleType=${ScheduleType.SINGLE_SHIFT}`;
    // Add shiftDate as url param
    // This allows direct invites to correctly set shift date when bulk single shift is enabled
    directInviteUrl += `&shiftDate=${formattedShiftDate}`

    if (singleShift) {
      directInviteUrl += `&singleAssignmentView=true`;
    }

    this.$window.location.href = directInviteUrl;
  }

  /*
   Redirect to GetCrewForm (web-react) with no pre-populated URL params
   for direct hire user with a shiftDate (in case of single-shift)
   for the date that they clicked on
  */
  directHireWithNoParams(shiftDate) {
    const SINGLE_SHIFT_SCHEDULE_TYPE = 1;
    let formattedShiftDate;
    let directInviteUrl = this.buildDirectHireUrlWithNoUserNorPosition();
    if (shiftDate) {
      formattedShiftDate = this.formatShiftDateToQueryParameterValue(shiftDate);
      directInviteUrl += `&startShiftDate=${formattedShiftDate}&endShiftDate=${formattedShiftDate}`;
    }
    directInviteUrl += `&scheduleType=${ScheduleType.SINGLE_SHIFT}`;
    // Add shiftDate as url param
    // This allows direct invites to correctly set shift date when bulk single shift is enabled
    directInviteUrl += `&shiftDate=${formattedShiftDate}`
    this.$window.location.href = directInviteUrl;
  }

  getAssignmentFormattedEndDate = memoize(userID => {
    const futureShifts = this.usersAllShifts[userID]
    if (!futureShifts || !futureShifts.lastFutureShift) return ''
    const endDate = futureShifts.lastFutureShift
    return moment(endDate).tz(this.timezone).format('MMM D')
  });

  getFutureShiftsCount = userID => {
    const futureShifts = this.usersAllShifts[userID]
    if (!futureShifts || !futureShifts.futureShiftCount) return null
    return futureShifts.futureShiftCount
  }

  getFutureShifts = (shifts, selectedStartDate, dateKey = 'start_time') => (
    // Shift can have different field names depending on the response from the API
    shifts.filter(shift =>
      moment(shift[dateKey]).tz(this.timezone).isSameOrAfter(selectedStartDate, 'day'))
  )

  getCompanyJobs = () => {
    this.showLoaderCircle = true
    return this.Jobs.companyJobs(this.company.internal_id, this.dateCutoff, this.futureDateCutoff)
      .then((data) => {
        this.group(data)
      })
  }

  getLiveShiftsCounts = () => {
    //Create date range between today and currently selected date
    const todayWithoutTimezone = this.moment().format('YYYY-MM-DD');
    const lastDayOfCurrentRosterView = this.moment(this.futureDateCutoff).endOf('day').format();
    const today = this.moment(todayWithoutTimezone).utcOffset(this.moment(lastDayOfCurrentRosterView).utcOffset(), true).startOf('day').format();
    const todayMoment = this.moment(today);
    const lastDayMoment = this.moment(lastDayOfCurrentRosterView);
    this.currentJobs = [];
    //Roster page optimization - This data is not needed when we view previous week roster
    if (!todayMoment.isSameOrBefore(lastDayMoment)) {
      return;
    }
    return this.Jobs.companyJobs(this.company.internal_id, today, lastDayOfCurrentRosterView)
      .then((data) => {
        data.shiftsGroupedByUser.forEach(shiftByUser => {
          const dedupe = {};
          shiftByUser.shifts = shiftByUser.shifts.filter(shift => {
            if (dedupe[shift.start_time]) {
              return false;
            } else {
              dedupe[shift.start_time] = true;
              return true;
            }
          })
        })
        this.currentJobs = data.shiftsGroupedByUser;
      });
  }

  addShiftCountsToJob = (jobs, userId, jobId) => {
    const futureShifts = this.usersAllShifts[userId];
    jobs.jobShiftsCount = 0;
    if (futureShifts.jobs.some((futureShift) => futureShift.jobId === jobId && moment(futureShift.lastShiftStart).isAfter(this.futureDateCutoff))) {
      jobs.jobShiftsCount += this.getFutureShiftsCount(userId);;
    }
    // Use Map for O(1) lookup instead of O(n) forEach
    const user = this.userShiftsMap.get(userId);
    if (user) {
      jobs.jobShiftsCount += user.shifts.reduce((accumulator, rcwShift) => {
        if (jobId === rcwShift.job_id) {
          return accumulator + 1;
        }
        return accumulator;
      }, 0);
    }
  }

  filterBlueShiftJobs = (userID) => {
    const allUserJobs = this.usersAllShifts[userID];
    if (!allUserJobs || !allUserJobs.jobs) return []
    return allUserJobs.jobs.filter(job => !job.blueshiftRequestId);
  }

  onEndAssignmentModal = (user) => {
    const userJobs = this.filterBlueShiftJobs(user.id)
    const jobShiftsCount = this.usersFutureShiftsFromToday[user.id]
    const endAssignmentModal = {
      controller: endAssignmentCtrl,
      controllerAs: 'e',
      template: endAssignmentTpl,
      fullscreen: true,
      scope: this.$scope,
      preserveScope: true,
      clickOutsideToClose: true,
      locals: {
        user,
        userJobs,
        timezone: this.timezone,
        jobShiftsCount
      },
    }
    return this.$mdDialog.show(endAssignmentModal);
  }

  onExtendAssignmentModal = (user) => {
    const userJobs = this.filterBlueShiftJobs(user.id)
    const extendAssignmentModal = {
      controller: extendAssignmentCtrl,
      controllerAs: 'e',
      template: extendAssignmentTpl,
      fullscreen: true,
      scope: this.$scope,
      preserveScope: true,
      clickOutsideToClose: true,
      locals: {
        user,
        userJobs,
        timezone: this.timezone,
      },
    }
    return this.$mdDialog.show(extendAssignmentModal);
  }


  group(data) {
    this.shifts = data.shifts;
    this.unfilledShifts = data.unfilledShifts

    // Build Map for O(1) user lookups
    this.userShiftsMap.clear();

    data.shiftsGroupedByUser.forEach(shiftByUser => {
      const dedupe = {};
      shiftByUser.shifts = shiftByUser.shifts.filter(shift => {
        if (dedupe[shift.start_time]) {
          return false;
        } else {
          dedupe[shift.start_time] = true;
          return true;
        }
      })

      // Add to Map for fast lookups
      this.userShiftsMap.set(shiftByUser.id, shiftByUser);
    })
    this.shiftsGroupedByUser = data.shiftsGroupedByUser.map((user) => {
      return {
        ...user,
        covid_icon: getCovidPolicyIcon(user),
      };
    });

    this.weeklyRosterCrewCopy = this.shiftsGroupedByUser
    this.weeklyRosterCrew = []

    /*
    this.groupedShiftsByUser is what adds or subtracts the class 'duplicate-shifts-divider'.
    The function t.hasDuplicateShifts looks at this.groupedShiftsByUser.
    You can see this happening in the roster.html file around line 333.
    Look for ng-class="{'duplicate-shifts-divider': t.hasDuplicateShifts(user.shifts)}" in roster.html
     */
    this.groupedShiftsByUser = groupBy(this.shifts, 'id')
    this.groupedShiftsBySupervisor = groupBy(this.shifts, 'supervisor')
    this.groupedShiftsByPosition = groupBy(this.shifts, 'positionName')
    this.groupedShiftsBySchedule = groupBy(this.shifts, 'schedule_name')
    this.groupedByDate = groupBy(this.shifts, 'day')
    this.groupedByUserAndDate = {}

    this.loadCrewMemberShiftProgressively();

    if (this.isWeeksView()) {
      if (this.shifts.length) {
        // initialize shifts and hours counts for each day of the week
        this.calculateShiftsAndHoursCounts(this.groupedByDate)

        // iterating through the days of the week and finding the max value for the greatest number of shifts
        this.numberOfShiftRows = this.daysOfWeekData.reduce((max, currentValue) => Math.max(max, currentValue.totalShiftCount), this.daysOfWeekData[0].totalShiftCount)
      }

      if (!this.shifts.length && this.unfilledShifts.length) {
        this.showUnfilledShifts = true
      }

      this.groupedUnfilledShifts = groupBy(this.unfilledShifts, 'job_id')
      this.unfilledShiftsLength = Object.keys(this.groupedUnfilledShifts).length
    }

    // figuring out days of the week between start/end dates
    var range = momentRange.range(this.dateCutoff, this.futureDateCutoff)
    const datesArray = Array.from(range.by('days'))
    this.daysOfWeek = datesArray.map(d => d.format('YYYY-MM-DD'))
    this.dayShift = []
    this.swingShift = []
    this.nightShift = []
    this.all = []
    // massage data
    this.jobs = data.jobs
    if (data.shifts && data.shifts.length) {
      this.timezone = data.shifts[0].timezone
      this.updatePdfRosterDates(this.dateCutoff)
    } else {
      this.timezone = moment.tz.guess()
    }
    this.todayClock = moment.tz(this.now, this.timezone).format('h:mma z')
    for (let shift of data.shifts) {
      let userRoster = clone(shift)
      userRoster.job = find(propEq('id', userRoster.job_id), (this.jobs))
      this.all.push({ ...userRoster, covid_icon: getCovidPolicyIcon(shift) });
    }
    this.all = this.$filter('filter')(this.all, {}, true)

    if (this.isToday) {
      this.dayShift = filter(propEq('status', 'Previous'), this.all)
      this.swingShift = filter(propEq('status', 'Current'), this.all)
      this.nightShift = filter(propEq('status', 'Upcoming'), this.all)
    } else {
      this.all = filter(propEq('day', this.todaysDate), this.all)
      this.dayShift = filter(propEq('shift_type', 'Day Shift'), this.all)
      this.swingShift = filter(propEq('shift_type', 'Swing Shift'), this.all)
      this.nightShift = filter(propEq('shift_type', 'Night Shift'), this.all)
    }

    // Need to store each CM's certifications in the shift otherwise, Angular will keep trying to re-fetch them
    // since it thinks an element has changed.
    this[this.filterCategory].forEach((shift, index) => {
      shift.userCertifications = shift.covid_icon.has_icon ? [shift.covid_icon] : [];
    });

    this.showShifts = this[this.filterCategory]
    this.facetCounts()
    this.showLoaderCircle = false
  }

  loadCrewMemberShiftProgressively() {
      const BATCH_DELAY_MS = 200;
      this.currentBatchIndex = 0;

      // Determine source data based on active filters
      const hasActiveFilters = !isEmpty(this.filter);
      const sourceData = hasActiveFilters
          ? this.applyActiveFilters(this.weeklyRosterCrewCopy)
          : this.weeklyRosterCrewCopy;

      this.totalCrewMembers = sourceData.length;
      this.loadedCrewMembers = 0;

      this.weeklyRosterCrew = [];
      this.initializeFutureShiftsSubscription();

      const loadNextBatch = () => {
          if (this.currentBatchIndex >= CREW_MEMBERS_BATCH) {
              this.showLoaderCircle = false;
              this.loadedCrewMembers = this.weeklyRosterCrew.length;
              this.$scope.$applyAsync();
              return;
          }

          const batch = sourceData.slice(this.currentBatchIndex, this.currentBatchIndex + CREW_MEMBERS_BATCH);
          this.weeklyRosterCrew = [...this.weeklyRosterCrew, ...batch];
          this.loadedCrewMembers = this.weeklyRosterCrew.length;

          this.triggerFutureShiftsForBatch(batch);
          this.prefetchNextBatch(sourceData, this.currentBatchIndex);

          this.$scope.$applyAsync();
          this.currentBatchIndex += CREW_MEMBERS_BATCH;
          setTimeout(loadNextBatch, BATCH_DELAY_MS);
      };

      loadNextBatch();
  }

  loadMoreCrewMembers() {
      // Determine the source based on whether filters are active
      const hasActiveFilters = !isEmpty(this.filter);
      const sourceData = hasActiveFilters
          ? this.applyActiveFilters(this.weeklyRosterCrewCopy)
          : this.weeklyRosterCrewCopy;

      if (!sourceData || this.weeklyRosterCrew.length >= sourceData.length) {
          return;
      }

      const BATCH_DELAY_MS = 200;
      const startIndex = this.weeklyRosterCrew.length;
      const endIndex = Math.min(startIndex + CREW_MEMBERS_BATCH, sourceData.length);

      const loadNextBatch = () => {
          if (this.currentBatchIndex >= endIndex) {
              this.loadedCrewMembers = this.weeklyRosterCrew.length;
              this.$scope.$applyAsync();
              return;
          }

          const batch = sourceData.slice(this.currentBatchIndex, this.currentBatchIndex + CREW_MEMBERS_BATCH);
          this.weeklyRosterCrew = [...this.weeklyRosterCrew, ...batch];
          this.loadedCrewMembers = this.weeklyRosterCrew.length;

          this.triggerFutureShiftsForBatch(batch);
          this.facetCounts();

          this.$scope.$applyAsync();
          this.currentBatchIndex += CREW_MEMBERS_BATCH;

          if (this.currentBatchIndex < endIndex) {
              setTimeout(loadNextBatch, BATCH_DELAY_MS);
          }
      };

      loadNextBatch();
  }

  hasMoreCrewMembers() {
      return this.weeklyRosterCrewCopy &&
             this.weeklyRosterCrew &&
             this.weeklyRosterCrew.length < this.weeklyRosterCrewCopy.length;
  }

    /**
     * Initialize a single subscription that will receive all future shift updates
     */
    initializeFutureShiftsSubscription() {
        if (this.futureShiftsSubscription) {
            this.futureShiftsSubscription.unsubscribe();
        }

        const companyId = this.company.internal_id;
        let targetDate = moment(this.futureDateCutoff).toDate();
        if (moment(targetDate).isBefore(Date.now())) {
            targetDate = moment(Date.now()).toDate();
        }
        const dateHash = moment(targetDate);

        // Create a single subscription that will accumulate all batch results
        this.futureShiftsSubscription = this.futureShiftService
            .getFutureShiftsObservable(companyId, dateHash)
            .subscribe((updates) => {
                for (const [userId, fsu] of Object.entries(updates)) {
                    fsu?.jobs.forEach((j) => {
                        const v1Job = findV1Job(j.jobId, this.jobs || []);
                        j.days = v1Job?.days || [];
                    });
                }
                // Merge updates into existing data
                this.usersAllShifts = { ...this.usersAllShifts, ...updates };
                this.$scope.$applyAsync();
            });
    }

    /**
     * Trigger API call for a specific batch of crew members
     */
    triggerFutureShiftsForBatch(batch) {
        if (!this.userCanPostJobs || !batch.length) return;

        const companyId = this.company.internal_id;
        let targetDate = moment(this.futureDateCutoff).toDate();
        if (moment(targetDate).isBefore(Date.now())) {
            targetDate = moment(Date.now()).toDate();
        }
        const dateHash = moment(targetDate);

        // This will trigger the API call but results come through the subscription
        this.futureShiftService.fetchFutureShiftsForBatch(
            companyId,
            targetDate,
            batch,
            dateHash
        );
    }

    /**
     * Prefetch the next batch of crew members in the background
     * @param {Array} sourceData - The source data array
     * @param {number} currentIndex - The current batch index
     */
    prefetchNextBatch(sourceData, currentIndex) {
        // Clear any existing prefetch
        this.prefetchedBatch = null;

        const nextBatchStart = currentIndex + CREW_MEMBERS_BATCH;
        const nextBatchEnd = nextBatchStart + CREW_MEMBERS_BATCH;

        // Check if there's a next batch to prefetch
        if (nextBatchStart >= sourceData.length) {
            return;
        }

        const nextBatch = sourceData.slice(nextBatchStart, Math.min(nextBatchEnd, sourceData.length));

        if (!nextBatch.length) return;

        this.prefetchInProgress = true;

        // Store the prefetched batch metadata
        this.prefetchedBatch = {
            batch: nextBatch,
            startIndex: nextBatchStart
        };

        // Trigger the API call for next batch (results will come through subscription)
        this.triggerFutureShiftsForBatch(nextBatch);

        this.prefetchInProgress = false;
    }

  removeFilter(type, filter) {
    this.filter = omit(type, this.filter)
    this.filterCategories()
  }

  resetFilters() {
    this.filter = {}
    this.filterCategories()
  }

  /**
   *
   * @param {any[]} arr
   * @param {string} key
   * @param {number []} values List of ReasonCodes
   * @returns {any[]}
   */
  getFilteredDailyResults(arr, key, values) {
    return arr.filter((v) => {
      const reason = get(v, key)
      return values.includes(reason)
    })
  }

  getFilteredWeeklyResults(arr, key, value) {
    return arr.filter((user) =>
      user.shifts.some(shift => shift[key] === value))
  }

  /**
   *
   * @param {any[]} arr
   * @param {String} key
   * @param {number[]} values List of reason codes
   * @returns {any[]}
   */
  getFilteredWeeklyResultsMultipleValues(arr, key, values) {
    return arr.filter((user) =>
      user.shifts.some(shift => values.includes(shift[key])))
  }

  calcTotalHours(user) {
    if (user.status === this.PayrollHoursStatus.APPROVED) {
      const minutes = differenceInMinutes(new Date(user.hoursEnd), new Date(user.hoursStart))
      return (minutes / 60 - user.lunchDuration).toFixed(2)
    }

    if (user.lunch !== parseInt(user.lunch)) {
      user.error = 'invalid lunch value'
      return ''
    }

    let start = null
    let end = null

    if (user.isEdited.start) {
      start = user.editedTimes.start
    } else if (user.clockedTimestamps.start) {
      start = user.clockedTimestamps.start.time
    } else {
      start = user.shiftStart
    }
    start = user.editedTimes.start

    if (user.isEdited.end) {
      end = user.editedTimes.end
    } else if (user.clockedTimestamps.end) {
      end = user.clockedTimestamps.end.time
    } else {
      end = user.shiftEnd
    }
    end = user.editedTimes.end

    if (start === null || end === null) {
      user.error = 'missing start or end'
      return ''
    } else {
      if (start > end) {
        user.error = 'start can\'t be after end'
        return ''
      }

      const hours = this.Shifts.calcTotalHours(start, end, user.lunch)
      if (hours < 0) {
        user.error = 'hours can\'t be negative'
        return ''
      }

      user.error = null
      return hours
    }
  }

  facetCounts() {
    const CATEGORY_FIELD = 'category'
    const REASON_CODE_FIELD = 'usersHoursReasonCode'
    if (this.isWeeksView()) {
      this.newCount = this.getFilteredWeeklyResults(this.weeklyRosterCrewCopy, 'new', 'New').length
      this.lateCount = this.getFilteredWeeklyResults(this.weeklyRosterCrewCopy, 'late', 'Late').length

      this.scheduledCount = this.getFilteredWeeklyResults(this.weeklyRosterCrewCopy, CATEGORY_FIELD, Category.Scheduled).length
      this.inCount = this.getFilteredWeeklyResults(this.weeklyRosterCrewCopy, CATEGORY_FIELD, Category.ClockedIn).length
      this.onBreak = this.getFilteredWeeklyResults(this.weeklyRosterCrewCopy, CATEGORY_FIELD, Category.OnBreak).length
      this.outCount = this.getFilteredWeeklyResults(this.weeklyRosterCrewCopy, CATEGORY_FIELD, Category.ClockedOut).length
      this.notClockedInCount = this.getFilteredWeeklyResults(this.weeklyRosterCrewCopy, CATEGORY_FIELD, Category.NotClockedIn).length

      this.cancelledByCrewMemberCount = this.getFilteredWeeklyResults(this.weeklyRosterCrewCopy, REASON_CODE_FIELD, ReasonCode.CancelledByCrewMember).length
      this.noCallNoShowCount = this.getFilteredWeeklyResults(this.weeklyRosterCrewCopy, REASON_CODE_FIELD, ReasonCode.NoCallNoShow).length
      this.unqualifiedCount = this.getFilteredWeeklyResults(this.weeklyRosterCrewCopy, REASON_CODE_FIELD, ReasonCode.Unqualified).length
      this.resignedCount = this.getFilteredWeeklyResults(this.weeklyRosterCrewCopy, REASON_CODE_FIELD, ReasonCode.Resigned).length
      this.walkoffCount = this.getFilteredWeeklyResults(this.weeklyRosterCrewCopy, REASON_CODE_FIELD, ReasonCode.Walkoff).length
      this.overfillCount = this.getFilteredWeeklyResults(this.weeklyRosterCrewCopy, REASON_CODE_FIELD, ReasonCode.Overfill).length
      this.sickCount = this.getFilteredWeeklyResultsMultipleValues(this.weeklyRosterCrewCopy, REASON_CODE_FIELD, ReasonCodesForFiltering.Sick).length
      this.absentCount = this.getFilteredWeeklyResults(this.weeklyRosterCrewCopy, REASON_CODE_FIELD, ReasonCode.Absent).length
      this.familyEmergencyCount = this.getFilteredWeeklyResultsMultipleValues(this.weeklyRosterCrewCopy, REASON_CODE_FIELD, ReasonCodesForFiltering.FamilyEmergency).length
      this.transportationCount = this.getFilteredWeeklyResultsMultipleValues(this.weeklyRosterCrewCopy, REASON_CODE_FIELD, ReasonCodesForFiltering.Transportation).length
      return
    }

    if (this.isDaysView()) {
      this.newCount = length(filter(propEq('new', 'New'), this.showShifts))
      this.lateCount = length(filter(propEq('late', 'Late'), this.showShifts))

      this.scheduledCount = length(filter(propEq(CATEGORY_FIELD, Category.Scheduled), this.showShifts))
      this.inCount = length(filter(propEq(CATEGORY_FIELD, Category.ClockedIn), this.showShifts))
      this.onBreak = length(filter(propEq(CATEGORY_FIELD, Category.OnBreak), this.showShifts))
      this.outCount = length(filter(propEq(CATEGORY_FIELD, Category.ClockedOut), this.showShifts))
      this.notClockedInCount = length(filter(propEq(CATEGORY_FIELD, Category.NotClockedIn), this.showShifts))

      this.cancelledByCrewMemberCount = length(filter(propEq(REASON_CODE_FIELD, ReasonCode.CancelledByCrewMember), this.showShifts))
      this.noCallNoShowCount = length(filter(propEq(REASON_CODE_FIELD, ReasonCode.NoCallNoShow), this.showShifts))
      this.unqualifiedCount = length(filter(propEq(REASON_CODE_FIELD, ReasonCode.Unqualified), this.showShifts))
      this.resignedCount = length(filter(propEq(REASON_CODE_FIELD, ReasonCode.Resigned), this.showShifts))
      this.walkoffCount = length(filter(propEq(REASON_CODE_FIELD, ReasonCode.Walkoff), this.showShifts))
      this.overfillCount = length(filter(propEq(REASON_CODE_FIELD, ReasonCode.Overfill), this.showShifts))
      this.absentCount = length(filter(propEq(REASON_CODE_FIELD, ReasonCode.Absent), this.showShifts))
      this.sickCount = this.getFilteredDailyResults(this.showShifts, REASON_CODE_FIELD, ReasonCodesForFiltering.Sick).length
      this.familyEmergencyCount = this.getFilteredDailyResults(this.showShifts, REASON_CODE_FIELD, ReasonCodesForFiltering.FamilyEmergency).length
      this.transportationCount = this.getFilteredDailyResults(this.showShifts, REASON_CODE_FIELD, ReasonCodesForFiltering.Transportation).length
      return
    }
  }

  handleSegmentEvent(evt) {
    this.segment.track(evt)
  }

  OpenJobPost(jobExternalId) {
    let confirm = this.$mdDialog.confirm()
      .title('Change this job to an optimized post?')
      .textContent('This will bypass these unfilled direct invites and open the spots to other qualified candidates based on their skills, ratings, experience, and location.')
      .ariaLabel('Reason')
      .ok('OK')
      .cancel('Cancel')

    this.$mdDialog.show(confirm)
      .then((msg) => {
        this.ManageJobs.wholePlatform({ jobId: jobExternalId, wholePlatform: true })
          .then(this.ManageJobs.startNickAlgo({ jobId: jobExternalId }), () => {
            this.$mdToast.showSimple('Error Opening Job Up')
            this.openedPost = true
          })
      })
  }

  filterStatus(filteredArray, category, isDaysView) {
    let filter
    // this.filter.category is overloaded to filter on both `category` and `usersHoursReasonCode`
    if (typeof category === 'string') {
      // When the category is a string, it is searching through the `category` field
      if (isDaysView) {
        filter = { category }
      } else {
        filter = { shifts: { category } }
      }
      return this.$filter('filter')(filteredArray, filter, true)
    }
    if (typeof category === 'number') {
      // When the category is a number, it is searching through the `usersHoursReasonCode` field
      if (isDaysView) {
        filter = { usersHoursReasonCode: this.filter.category }
      } else {
        filter = { shifts: { usersHoursReasonCode: this.filter.category } }
      }
      return this.$filter('filter')(filteredArray, filter, true)
    }
    if (Array.isArray(category)) {
      // Currently the array only supports usersHoursReasonCode
      if (isDaysView) {
        return this.$filter('filter')(filteredArray, (arg) => {
          const categoriesToMatch = category
          return categoriesToMatch.includes(arg.usersHoursReasonCode)
        })
      } else {
        return this.$filter('filter')(filteredArray, (arg) => {
          return arg.shifts.map(shift => {
            const categoriesToMatch = category
            return categoriesToMatch.includes(shift.usersHoursReasonCode)
          }).includes(true)
        })
      }
    }
  }

  /**
   * Apply all active filters to the crew members list
   * @param {Array} crewMembers - The crew members to filter
   * @returns {Array} - The filtered crew members
   */
  applyActiveFilters(crewMembers) {
    let filtered = this.$filter('filter')(crewMembers, { fullname: this.filter.name });

    if (this.filter.category) { filtered = this.filterStatus(filtered, this.filter.category, this.isDaysView()); }
    if (this.filter.positionName) { filtered = this.$filter('filter')(filtered, { shifts: { positionName: this.filter.positionName } }, true); }
    if (this.filter.schedule_name) { filtered = this.$filter('filter')(filtered, { shifts: { schedule_name: this.filter.schedule_name } }, true); }
    if (this.filter.title) { filtered = this.$filter('filter')(filtered, { shifts: { title: this.filter.title } }, true); }
    if (this.filter.start_time) { filtered = this.$filter('filter')(filtered, { shifts: { start_time: this.filter.start_time } }, true); }
    if (this.filter.new) { filtered = this.$filter('filter')(filtered, { new: this.filter.new }, true); }
    if (this.filter.late) { filtered = this.$filter('filter')(filtered, { shifts: { late: this.filter.late } }, true); }
    if (this.filter.supervisor) { filtered = this.$filter('filter')(filtered, { shifts: { supervisor: this.filter.supervisor } }, true); }
    if (this.filter.covidVaccinated) { filtered = filtered.filter(cm => cm.covid_icon.has_icon); }

    return filtered;
  }

  handleSearchTrigger() {
    this.debouncedFilterCategories()
  }

  /**
   * Debounced version of filterCategories to prevent excessive re-renders during typing
   * @type {DebouncedFunc<function(): void>}
   */
  debouncedFilterCategories = debounce(() => {
    this.filterCategories();
  }, FILTER_DEBOUNCE_TIME);

  filterCategories() {
    this.filter = pickBy(identity, this.filter)
    this.filterCount = Object.keys(this.filter).length

    // Clear prefetch state when filters change
    this.prefetchedBatch = null;
    this.prefetchInProgress = false;

    // Segment Event Tracking
    this.segment.track(rosterFilterEvent, {
      filters: this.filter
    })

    // Daily Roster Filter
    if (this.isDaysView()) {
      let filtered = this.$filter('filter')(this[this.filterCategory], { fullname: this.filter.name })

      if (this.filter.category) { filtered = this.filterStatus(filtered, this.filter.category, this.isDaysView()) }
      if (this.filter.positionName) { filtered = this.$filter('filter')(filtered, { positionName: this.filter.positionName }, true) }
      if (this.filter.schedule_name) { filtered = this.$filter('filter')(filtered, { schedule_name: this.filter.schedule_name }, true) }
      if (this.filter.title) { filtered = this.$filter('filter')(filtered, { title: this.filter.title }, true) }
      if (this.filter.start) { filtered = this.$filter('filter')(filtered, { start_time: this.filter.start }, true) }
      if (this.filter.new) { filtered = this.$filter('filter')(filtered, { new: this.filter.new }, true) }
      if (this.filter.late) { filtered = this.$filter('filter')(filtered, { late: this.filter.late }) }
      if (this.filter.supervisor) { filtered = this.$filter('filter')(filtered, { job: { supervisor: this.filter.supervisor } }, true) }
      if (this.filter.covidVaccinated) { filtered = filtered.filter(cm => cm.covid_icon.has_icon)}

      this.showShifts = filtered
    }

    // Weekly Roster Filter
    if (this.isWeeksView()) {
      // Reset and reload crew members with current filter state
      this.currentBatchIndex = 0;
      this.weeklyRosterCrew = [];

      const hasActiveFilters = !isEmpty(this.filter);
      const sourceData = hasActiveFilters
          ? this.applyActiveFilters(this.weeklyRosterCrewCopy)
          : this.weeklyRosterCrewCopy;

      this.totalCrewMembers = sourceData.length;

      // Load first batch
      const batch = sourceData.slice(0, Math.min(CREW_MEMBERS_BATCH, sourceData.length));
      this.weeklyRosterCrew = batch;
      this.loadedCrewMembers = batch.length;
      this.currentBatchIndex = batch.length;

      // Trigger future shifts for the loaded batch
      this.triggerFutureShiftsForBatch(batch);

      // Calculate shifts and hours counts
      const filteredShifts = [];
      this.weeklyRosterCrew.forEach(worker => {
        worker.shifts.forEach(shift => {
          filteredShifts.push(shift);
        });
      });

      // grouping the separated and filtered list of shifts by day
      this.groupedFilteredShifts = groupBy(filteredShifts, 'day');

      // recalculate shifts and hours counts
      if (hasActiveFilters) {
        this.calculateShiftsAndHoursCounts(this.groupedFilteredShifts);
      } else {
        this.calculateShiftsAndHoursCounts(this.groupedByDate);
      }

      // Update facet counts after weeklyRosterCrew update
      this.facetCounts();
    }
    this.showFilters = !isEmpty(this.filter)
  }

  toggleShiftFilter(shiftType) {
    this.filterCategory = shiftType
    if (this.isToday) {
      this.dayShift = filter(propEq('status', 'Previous'), this.all)
      this.swingShift = filter(propEq('status', 'Current'), this.all)
      this.nightShift = filter(propEq('status', 'Upcoming'), this.all)
    } else {
      this.all = filter(propEq('day', this.todaysDate), this.all)
      this.dayShift = filter(propEq('shift_type', 'Day Shift'), this.all)
      this.swingShift = filter(propEq('shift_type', 'Swing Shift'), this.all)
      this.nightShift = filter(propEq('shift_type', 'Night Shift'), this.all)
    }
    this.showShifts = this[this.filterCategory]
    this.facetCounts()

    if (shiftType === 'all') {
        this.filterCategories()
    }
  }

  selectAll(){
    for (let worker in this.showShifts) {
      worker.selected = true
    }
  }

  deselectAll() {
    this.showShifts = map(dissoc('selected'), this.showShifts)
  }

  calculateShiftsAndHoursCounts(groupedList) {
    this.daysOfWeekData = []

    Object.keys(groupedList).map(key => {
      const data = {
        day: groupedList[key][0].day,
        totalShiftCount: groupedList[key].length,
        totalDailyShiftTime: groupedList[key].reduce((sum, shift) => {
          // if a shift is greater than 5 hours(300 minutes) subtract min lunch
          if (shift.totalDailyShiftTime > 300) {
            return sum + (shift.totalDailyShiftTime - shift.minLunch)
          } return sum + shift.totalDailyShiftTime
        }, 0)
      }

      this.daysOfWeekData.push(data)
    })
  }

  getCompanyTimestamps(getSince){
    this.Jobs.companyTimestamps(this.company.internal_id, getSince)
      .then((timestamps) => {
        let objKeys = keys(timestamps)

        if (!objKeys.length) return
        for (let userId in timestamps) {
          let userIdInt = parseInt(userId)
          let shiftIndex = findIndex(propEq('id', userIdInt))(this.showShifts)
          let weeklyUserIndex = findIndex(propEq('id', userIdInt))(this.weeklyRosterCrew)
          let allIndex = findIndex(propEq('id', userIdInt))(this.all)

          this.Jobs.getIndividualRosterUpdates({
            companyId: this.company.internal_id,
            externalUserId: timestamps[userId].external_user_id,
            shift: timestamps[userId].shift,
            externalJobId: timestamps[userId].external_job_id,
          }).then((updatedRosterProps) => {

            if (!this.all[allIndex]) return
            let weeklyShiftIndex = findIndex(propEq('shift', timestamps[userIdInt].shift))(this.weeklyRosterCrew[weeklyUserIndex].shifts)

            // DAILY ROSTER REAL TIME
            this.$scope.updateRosterProps(this.showShifts[shiftIndex], updatedRosterProps)
            if (!this.showShifts[shiftIndex].timestamps) {
              this.showShifts[shiftIndex].timestamps = timestamps[userId].timestamps
            } else {
              this.showShifts[shiftIndex].timestamps.concat(timestamps[userId].timestamps)
              this.showShifts[shiftIndex].timestamps = sortBy(this.showShifts[shiftIndex].timestamps, 'id')
            }

            // WEEKLY ROSTER REAL TIME
            this.$scope.updateRosterProps(this.weeklyRosterCrew[weeklyUserIndex].shifts[weeklyShiftIndex], updatedRosterProps)
            if (!this.weeklyRosterCrew[weeklyUserIndex].shifts[weeklyShiftIndex].timestamps) {
              this.weeklyRosterCrew[weeklyUserIndex].shifts[weeklyShiftIndex].timestamps = timestamps[userId].timestamps
            } else {
              this.weeklyRosterCrew[weeklyUserIndex].shifts[weeklyShiftIndex].timestamps.concat(timestamps[userId].timestamps)
              this.weeklyRosterCrew[weeklyUserIndex].shifts[weeklyShiftIndex].timestamps = sortBy(this.weeklyRosterCrew[weeklyUserIndex].shifts[weeklyShiftIndex].timestamps, 'id')
            }

            // ALL OBJECT ROSTER REAL TIME
            this.$scope.updateRosterProps(this.all[allIndex], updatedRosterProps)
            if (!this.all[allIndex].timestamps) {
              this.all[allIndex].timestamps = timestamps[userId].timestamps
            } else {
              this.all[allIndex].timestamps.concat(timestamps[userId].timestamps)
              this.all[allIndex].timestamps = sortBy(this.all[allIndex].timestamps, 'id')
            }

            if (objKeys.length === 1) {
              this.$mdToast.showSimple(`${this.all[allIndex].fullname} Clocked ${timestamps[userId].currently_clocked_in ? 'in' : 'out'}`)
            }

            return updatedRosterProps
          }).catch((err) => {
            this.$mdToast.showSimple(err)
          })
        }
        this.$scope.$applyAsync();
      })
  }

  // eslint-disable-next-line
  calcTotalHours(timeIn, timeOut, lunch){
    let diff = differenceInHours(timeIn, timeOut)
    if (diff < 0) {
      diff += 24
    }
    if (diff > 5) { diff -= (lunch / 60) }

    return diff
  }

  showEditTime(roster, startClock, endClock) {
    let edit = {
      controller: showEditTimeCtrl,
      controllerAs: 'm',
      template: showEditTimeTpl,
      fullscreen: true,
      clickOutsideToClose: true,
      locals: {
        roster: roster,
        startClock,
        endClock
      }
    }
    return this.$mdDialog.show(edit)
  }

  showAddWorker(job, selectedShift){
    let confirm = {
      controller: addWorkerCtrl,
      controllerAs: 'add',
      template: addWorkerTpl,
      fullscreen: true,
      scope: this.$scope,
      preserveScope: true,
      clickOutsideToClose: true,
      locals: {
        job: job,
        Users: this.Users,
        shift: selectedShift,
        workforce: this.myWorkforce
      }
    }
    return this.$mdDialog.show(confirm)
      .then()
      .finally(() => {
        confirm = undefined
        return this.$mdDialog.hide()
      })
  }

  messageGroup($ev, workers){
    const confirm = {
      controller: msgCtrl,
      controllerAs: 'm',
      template: msgTpl,
      targetEvent: $ev,
      clickOutsideToClose: true
    }

    return this.$mdDialog.show(confirm)
      .then((msg) => this.Message.messageGroupFromCompany({
        messages: map(() => msg, keys(workers)),
        userIds: keys(workers)
      }))
      .then(
        (msg) => this.$mdToast.showSimple(msg),
        () => this.$mdToast.showSimple('Unable to send message.')
      )
  }

  showRateWorker($ev, roster, ratingType) {
    const confirm = {
      controller: dsbCtrl,
      controllerAs: 'm',
      template: rateTpl,
      fullscreen: true,
      targetEvent: $ev,
      clickOutsideToClose: true,
      locals: {
        worker: roster,
        job: roster.job,
        schedule: null,
        ratingType: ratingType
      }
    }
    let dsbResults
    return this.$mdDialog.show(confirm)
      .then((results) => {
        dsbResults = results
        if (!dsbResults.endDate) return this.Users.dontSend(roster.external_id, dsbResults.reason, dsbResults.dsbRating, dsbResults.categoryId, roster.job.external_id)
        this.Jobs.repost({
          dsb: 1,
          jobId: roster.job.external_id,
          startDate: results.startDate,
          needed: results.needed,
          timezone: results.timezone,
          endDate: results.endDate,
          days: results.days
        }).then(this.Users.dontSend(roster.external_id, dsbResults.reason, dsbResults.dsbRating, dsbResults.categoryId, roster.job.external_id))
      })
      .then(this.Users.removeWorker(roster.external_id))
      .then(this.Users.getWorkforce())
      .then(this.dontSendSuccess.bind(this))
      .catch(this.dontSendError.bind(this))
  }

  dsb($ev, roster){
    if (roster.job) roster.job.timezone = roster.timezone
    const confirm = {
      controller: dsbCtrl,
      controllerAs: 'dsb',
      template: dsbTpl,
      fullscreen: true,
      targetEvent: $ev,
      clickOutsideToClose: true,
      locals: {
        worker: roster.worker,
        job: roster.job,
        schedule: null, // gets filled in below if roster.schedule_id exists
        ratingType: null
      }
    }
    let fetchScheduleDetails = Promise.resolve()
    if (roster.schedule_id) {
      fetchScheduleDetails = this.Jobs.getScheduleDetails(roster.schedule_id).then((response) => {
        confirm.locals.schedule = response.schedule
      })
    }
    let dsbResults
    return fetchScheduleDetails.then(() => this.$mdDialog.show(confirm))
      .then((results) => {
        dsbResults = results
        if (!dsbResults.endDate) return this.Users.dontSend(roster.external_id, dsbResults.reason, dsbResults.dsbRating, dsbResults.categoryId, roster.job.external_id)
        this.Jobs.repost({
          days: results.days,
          daysOfWeek: roster.days,
          department: roster.department_id, // department id
          dsb: 1,
          endDate: results.endDate,
          jobId: roster.job.external_id,
          needed: results.needed,
          positionId: roster.position_id,
          startDate: results.startDate,
          supervisor: roster.supervisor_id, // supervisor id
          timezone: results.timezone,
          wage: roster.base_wage
        }).then(this.Users.dontSend(roster.external_id, dsbResults.reason, dsbResults.dsbRating, dsbResults.categoryId, roster.job.external_id))
      })
      .then(this.Users.removeWorker(roster.external_id))
      .then(this.Users.getWorkforce())
      .then(() => {
        roster.dont_send_back = true
        this.$mdToast.showSimple(`Marked ${roster.fullname} as don\'t send.`)
      })
      .catch(this.dontSendError.bind(this))
  }

  dontSendError(err){
    this.$scope.$broadcast('app:loading:done')
    if (!err) return
    console.error(err)
    this.$mdToast.showSimple('Unable to mark user as don\'t send.')
  }

  showMarkAbsent($ev, roster) {
    const confirm = {
      controller: absentModalController,
      controllerAs: 'm',
      template: absentModalTemplate,
      fullscreen: true,
      targetEvent: $ev,
      clickOutsideToClose: true,
      locals: {
        roster: roster,
      }
    }
    return this.$mdDialog.show(confirm)
      .then((res) => {
        this.$mdToast.showSimple(`Marked ${roster.fullname} absent`)
        this.$scope.updateRosterProps(res.roster, { category: res.category, usersHoursReasonCode: res.usersHoursReasonCode })
        if (res.dsb) {
          this.dsb($ev, roster)
        }
      })
  }

  rate(rating, shift){
    const promises = map(
      pipe(
        of,
        ap([prop('userIds'), prop('job.external_id')]),
        prepend(rating),
        apply(this.Users.rate)
      ),
      [shift])

    this.$q.all(promises).then(
      () => {
        this.$mdToast.showSimple('Users rated successfully.')
        this.deselectAll()
      },
      () => this.$mdToast.showSimple('Unable to rate.')
    )
  }

  favorite(worker) {
    this.Users.favorite([worker.external_id], worker.job.external_id)
      .then((res) => {
        worker.is_favorite = true;
        const msg = `${worker.fullname} added as a favorite!`
        this.$mdToast.showSimple(msg)
      })
    // .catch(this.$mdToast.showSimple('Error marking user as favorite'))
  }

  /**
   * Open the "Cancel a Shift" modal
   * @param {object} $ev - target event
   * @param {CrewMemberAndShift} crewMemberAndShift
   */
  openCancelModal = ($ev, crewMemberAndShift) => {
    const currentTime = moment(Date.now()).tz(crewMemberAndShift.timezone);
    const shiftInProgress = currentTime.isSameOrAfter(moment(crewMemberAndShift.start_time)
      .subtract(30, "minutes")) && currentTime.isBefore(moment(crewMemberAndShift.end_time));
    this.addShiftCountsToJob(crewMemberAndShift.job, crewMemberAndShift.id, crewMemberAndShift.job_id);
    const cancelModal = {
      controller: cancelShiftModalCtrl,
      controllerAs: 'c',
      template: cancelShiftModal,
      fullscreen: true,
      targetEvent: $ev,
      clickOutsideToClose: true,
      locals: {
        selectedShift: crewMemberAndShift,
        selectedUser: [crewMemberAndShift],
        shiftJob: crewMemberAndShift.job,
        shiftInProgress: shiftInProgress,
      },
    };

    this.$mdDialog.show(cancelModal);
  }


  /**
   * Check if the "Cancel a shift" button should be enabled for a given shift
   * @param {CrewMemberAndShift} selectedShift
   * @return {boolean}
   */
  getPastShift = (selectedShift) => {
    const shiftStartDay = moment.tz(selectedShift.start_time, selectedShift.timezone);
    const today = moment().tz(selectedShift.timezone);
    return shiftStartDay.isBefore(today);
  }

  /**
   * Check if the "Cancel a shift" button should be enabled for a given shift
   * @param {CrewMemberAndShift} crewMemberAndShift
   * @return {boolean}
   */
  checkIfCannotCancel = (crewMemberAndShift) => {
    /**
     * NOTE: This logic is copy-pasted from ShiftDetails.jsx
     *
     * TODO(BW-2338): Setup an angular service for calculating 'shiftInProgress' as well as 'cannotCancel'
     * and then use it in both places, if possible to reduce duplication of business logic
     *
     * https://bluecrewjobs.atlassian.net/browse/BW-2338
    */
    const currentTime = moment(Date.now()).tz(crewMemberAndShift.timezone);
    const shiftNotInProgress = !(currentTime.isSameOrAfter(moment(crewMemberAndShift.start_time)
      .subtract(30, "minutes")) &&
      currentTime.isBefore(moment(crewMemberAndShift.end_time)));

    const excused = crewMemberAndShift.excused;
    const pastShift = this.getPastShift(crewMemberAndShift);
    return (shiftNotInProgress && pastShift) || (excused != undefined) || !this.userCanPostJobs;
  }

  unfavorite(worker){
    this.Users.unfavorite([worker.external_id], worker.job.external_id)
      .then((res) => {
        worker.is_favorite = false;
        const msg = `${worker.fullname} removed as favorite`
        this.$mdToast.showSimple(msg)
      })
    // .catch(this.$mdToast.showSimple('Error marking user as favorite'))
  }
}

export default currentJobsController
